Application.Signature.Color = {
    ui: {
        container: '.js-signature-color.step-color',
        previewContainer: '.step-color__preview',
        preview: '.step-preview__preview-icon',
        previewIconContainer: '.step-preview__preview-icon-container',
        input: '.step-preview__svg-input',
        inputSettings: '.step-preview__settings-input'
    },
    previewList: null,
    state: {
        iconReady: false
    },
    handlers: {
        iconReady: []
    },
    ready: function (previewList) {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // children
        this.Transformer.ready(this);
        this.Mover.ready(this);

        // bind handlers
        this.bind();

        // create icon
        this.svgIcon = new Application.SvgIcon();
        // append to DOM
        $(this.ui.preview).append(this.svgIcon.element);
        // set size
        var ratio = $(this.ui.preview).data('icon-width-ratio');
        $(this.ui.previewIconContainer).css('width', (ratio * $(this.ui.previewIconContainer).data('width')) + 'em');
        // set x position
        $(this.ui.preview).css('margin-left', $(this.ui.previewIconContainer).data('x') + 'em');
        // set icon
        this.svgIcon.setIcon(
            $(this.ui.preview).data('icon'),
            null,
            Application.SvgIcon.FIT_WIDTH,
            function(){
                self.triggerIconReady();
        });

    },
    bind: function(){

        var self = this;

        // update color when requested
        this.previewList.setOnChange(function(id, src, data){
            self.color(id, src, typeof data.settings !== 'undefined' ? data.settings : null);
        });
        // update transformer scaling on zoom
        this.previewList.setOnZoom(function(multiplier){
            self.scale(multiplier);
            self.Mover.reset();
        });

        // transformer
        this.Transformer.on('move', function(x, y){
            self.move(x, y);
        });
        this.Transformer.on('resize', function(x, y, w, h){
            self.resize(x, y, w, h);
        });
        this.Transformer.on('rotate', function(a){
            self.rotate(a);
        });

    },
    color: function(id, src, settings){

        var self = this;

        this.onIconReady(function(){

            // no background
            if (!src){
                self.svgIcon.setBackground('#333');
                // load settings
                if (settings){
                    self.svgIcon.loadSettings(settings);
                }
                // disable transformer
                self.disableTransformer();
                // update input
                self.updateInput();
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
                return;
            }

            // icon
            self.svgIcon.setBackground(src, function(){
                // load settings
                if (settings){
                    self.svgIcon.loadSettings(settings);
                }
                // enable transformer
                self.enableTransformer();
                // update transformer size
                var bbox = self.svgIcon.getBackgroundBbox();
                self.Transformer.setBackground(src);
                self.Transformer.setPosition(bbox.x, bbox.y, bbox.w, bbox.h);
                self.Transformer.setRotation(settings ? settings.a : 0);
                // update input
                self.updateInput();
                // mark as ready
                $(self.ui.container).removeClass('step-preview_loading');
            });

        });

    },
    scale: function(m){

        this.Transformer.setScale(m);
        this.Mover.setScale(m);

    },
    move: function(x, y){

        this.svgIcon.moveBackground(x, y);
        this.updateInput();

    },
    resize: function(x, y, w, h){

        this.svgIcon.moveBackground(x, y);
        this.svgIcon.resizeBackground(w, h);
        this.updateInput();

    },
    rotate: function(a){

        this.svgIcon.rotateBackground(a);
        this.updateInput();

    },
    updateInput: function(){

        $(this.ui.input).val(this.svgIcon.getSvg());
        $(this.ui.inputSettings).val(JSON.stringify(this.svgIcon.getSettings()));

    },
    disableTransformer: function(){

        $(this.ui.previewContainer).addClass('step-color__preview_transformer-disabled');
        this.Transformer.stop();

    },
    enableTransformer: function(){

        $(this.ui.previewContainer).removeClass('step-color__preview_transformer-disabled');

    },
    onIconReady: function(callback){

        if (this.state.iconReady){
            callback();
        }else{
            this.handlers.iconReady.push(callback);
        }

    },
    triggerIconReady: function(){

        // save state
        this.state.iconReady = true;

        // call
        for(var z in this.handlers.iconReady){
            if(!this.handlers.iconReady.hasOwnProperty(z)){
                continue;
            }
            this.handlers.iconReady[z].call(this);
        }
        // and reset
        this.handlers.iconReady = [];

    }
};